import type { ReactNode } from 'react';

export const symbol_nest_cam_wall_mount: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M102-285.03Q80-307.06 80-338v-304.59Q80-674 102.04-696q22.05-22 53-22Q186-718 208-696.5t22 52.5q33-62 94.23-100 61.23-38 135.77-38 52 0 99.5 19.5T644-706l187 187q8 8 12.5 19.5T848-477q0 11-4.5 22.5T831-435L548-152q-9 9-20 13.5t-22 4.5q-11 0-22.5-4.5T463-152L276-338q-14-14-25.5-29.5T230-400v62q0 30.94-22.04 52.97-22.05 22.03-53 22.03Q124-263 102-285.03ZM270-523q0 38 14.5 73t41.55 62.05L506-208l268-269-179.95-179.95Q567-684 532.65-698.5 498.31-713 460.26-713 381-713 325.5-657.58 270-602.17 270-523Zm252 63Z"
		/>
	</svg>
);
